module.exports = __webpack_public_path__ + "media/images/webpage/hotels/539/floorguide/course-3-photo-10-da20653b34fed4bbe2174d6100757221.webp";